<template>
	<li class="search-results__item card__item flex-basis-25 add-large-top-padding">
		<div class="search-results__item--image cover-card add-bottom-margin">
			<div class="search-results__item-contents">
				<button class="btn btn--black btn--tertiary type-small quick-view js-show-quick-view" @click="toggleModal">Quick View</button>
				<a :href="href(result, true)">
					<div class="search-results__item-container">
						<img :src="productImage(result)" class="full-cover" :alt="result.Name">
					</div>
				</a>
			</div>
		</div>
		<div class="search-results__item--text">
			<div>
				<a class="search-results__item-link color-black" :href="href(result, true)">
					<h5 class="type-h5 add-x-small-bottom-margin">{{result.Name}}</h5>
				</a>
				<p class="type-small add-x-small-bottom-margin color-silver-dark" v-if="result.Authors.length > 0">
					<span v-if="result.Authors.length <= 2" v-for="(name, index) in result.Authors">
						{{name.FirstName}} {{name.LastName}}<span v-if="index !== result.Authors.length - 1">, </span>
					</span>
					<span v-else-if="result.Authors.length > 2 && index === 0">
						Multiple Authors
					</span>
				</p>
				<p class="flex add-x-small-bottom-margin flex" v-if="result.ProductVariants && result.ProductVariants.length > 0">
					<span class="type-small no-bottom-margin type-bold" v-if="result.ProductVariants.length === 1">
						{{result.ProductVariants[0].Price}}
					</span>
					<span class="type-small no-bottom-margin type-bold" v-else="result.ProductVariants.length > 1">
						{{sortRetailPrices(result.ProductVariants)}}
					</span>
				</p>
				<p class="type-small no-bottom-margin color-silver-dark" v-if="result.ProductVariants && result.ProductVariants.length === 1">
					{{result.ProductVariants.length}} option
				</p>
				<p class="type-small no-bottom-margin color-silver-dark" v-else-if="result.ProductVariants">
					{{result.ProductVariants.length}} options
				</p>
			</div>
		</div>
		<div class="modal quick-view-modal" v-if="modalOpen">
			<div class="modal__overlay" tabindex="-1" data-micromodal-close>
				<div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title" :aria-describedby="'modal-' + result.Id">
					<div role="document">
						<header class="modal__header">
							<button class="modal__close" aria-label="Close modal" @click="toggleModal" aria-controls="modal__container1"></button>
						</header>
						<main class="modal__content flex add-large-bottom-padding" :id="'modal-' + result.Id">
							<QuickViewModal :product="result.Id" :catalog="'shop'"></QuickViewModal>
						</main>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>
	import AddToWishlist from './AddToWishlist.vue';
	import QuickViewModal from './QuickViewModal.vue';

	export default {
		name: 'GlobalSearchShopResults',
		props: ['result'],
		components: {
			QuickViewModal,
			AddToWishlist,
		},
		data() {
			return {
				modalOpen: false,
			}
		},
		methods: {
			productImage(result) {
				if (result.ProductImages.length) {
					const image = result.ProductImages.find(item => item.Height === 300);
					return image.ImageUrl
				} else {
					return '/images/default-card.png';
				}
			},

			href(product, retail = false) {
				let path = 'p';
				if (retail) {
					path = 's';
				}
				return `/${path}/${product.Id}/${product.SeName}`;
			},

			sortRetailPrices(prices) {
				prices.concat().sort((a, b) => { return Number(a.Price.replace(/(^\$)/g,'')) - Number(b.Price.replace(/(^\$)/g,'')); })

				return `${prices[0].Price} - ${prices[prices.length - 1].Price}`;
			},

			getAuthorHref(author){
				return `/a/${author.Id}/${author.SeName}`;
			},

			toggleModal(id) {
				this.modalOpen = !this.modalOpen;
			},

      // from https://laracasts.com/discuss/channels/general-discussion/escape-html-characters-with-vuejs
      decodeHtmlEntities(str) {
        var txt = document.createElement("textarea");
        txt.innerHTML = str;
        return txt.value;
      },

			licenseRequestPath(product) {
				return `${window.env.ZOHRAB_LICENSE_DOMAIN}/performance-license/license?productId=${product.Id}`;
			},
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/GlobalSearchShopResults.vue